var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: {
      'recipe-card': true,
      active: _vm.active
    }
  }, [_c('div', {
    staticClass: "name"
  }, [_c('h3', [_vm._v(" #" + _vm._s(this.recipe.hasOwnProperty("NoId") ? this.recipe.NoId : "?") + " - " + _vm._s(this.recipe.name) + " ")]), _vm.recipe.createdBy ? _c('span', [_vm._v(_vm._s(_vm.recipe.createdBy.name))]) : _vm._e()]), _c('div', {
    staticClass: "time"
  }, [_c('div', {
    staticClass: "verify",
    style: _vm.diffStyle
  }, [_vm._v(" " + _vm._s(_vm.statusToText(this.recipe.status)) + " ")]), _c('span', [_vm._v(_vm._s(_vm.formatedDate(this.recipe.createdAt)))])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }